import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import { isBrowser } from '@helpers/utils';
import clsx from 'clsx';

import SEO from '@common/SEO';
import Main from '@common/Main';
import Section from '@common/Section';
import Container from '@common/Container';
import Row from '@common/Row';
import Heading from '@common/Heading';

import ArticleCard from '@components/blog/post/ArticleCard';
import Pagination from '@components/blog/category-page/Pagination';

const ARTICLES = 12;

export const query = graphql`
  query($slug: String!) {
    wpUser(slug: { eq: $slug }) {
      name
      description
      avatar {
        url
      }
      posts {
        nodes {
          author {
            node {
              name
              slug
              avatar {
                url
              }
            }
          }
          date
          featuredImage {
            node {
              sourceUrl
            }
          }
          link
          title
          categories {
            nodes {
              name
              link
            }
          }
        }
      }
    }
  }
`

const Author = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [range, setRange] = useState([0, ARTICLES]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    name,
    description,
    posts,
    avatar
  } = data?.wpUser;
  const [totalPages,setTotalPages] = useState(Math.ceil((posts?.nodes.length)/ARTICLES));
  const next = () => setCurrentPage(currentPage+1);
  const prev = () => setCurrentPage(currentPage-1);
  const goToPage = page => setCurrentPage(page);
  const reloadPagination = () => {
    setIsLoading(true);
    isBrowser() && window.scrollTo(0, 0);
    setTimeout(() => setIsLoading(false), 700);
  }
  useEffect(() => {
    setRange([(((currentPage-1)*ARTICLES)),(ARTICLES*currentPage)])
    reloadPagination();
  },[currentPage]);
  useEffect(() => {
    setTotalPages(Math.ceil((posts?.nodes.length)/ARTICLES))
    if (currentPage === 1){
      reloadPagination();
    } else {
      setCurrentPage(1);
    }
  },[posts?.nodes]);
  return (
    <Main>
      <Section spacing='mt-5'>
        <Container>
          <Row>
            {avatar &&
              <div className='col-auto'>
                <img src={avatar.url} className='rounded-circle border border-dark-grey-4 border-2 ml-2' alt='' />
              </div>
            }
            <div className='col'>
              {name && <Heading type='h1'>{name}</Heading>}
              <p>{description ? description : `Articles written by ${name}`}</p>
            </div>
          </Row>
          <Row className={clsx('my-3', {'row-cols-md-2 row-cols-lg-3 g-3': posts?.nodes.length > 0})}>
            {posts?.nodes.slice(range[0], range[1]).map((post, index) => {
              if (isLoading) {
                return (
                  <ArticleCard.Loading key={index} show={isLoading}/>
                )
              }
              return (
                <ArticleCard key={index} data={post} show={isLoading}/>
              )
            })}
            {(posts?.nodes.length === 0) && 
              <Heading type='h3' className='d-inline-block mt-5 ms-1'>{'Sorry, there are no results that match the filter criteria!'}</Heading>
            }
          </Row>
          <div className='mt-1 d-flex justify-content-center'>
            {(posts?.nodes.length > ARTICLES) && 
              <Pagination prev={prev} next={next} goToPage={goToPage} currentPage={currentPage} totalPages={totalPages}/>
            }
          </div>
        </Container>
      </Section>
    </Main>
  );
};

export default Author

export const Head = ({ location, data }) => {
  const { name, avatar } = data?.wpUser;
  return (
    <SEO
      index={true}
      titleTag={name}
      location={location}
      metaImageUrl={avatar?.url}
    />
  )
}
